// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./sass/main.scss";
import App from "./components/App";

ReactDOM.render(<App />, document.getElementById("root"));
